import { useState, useEffect, useRef } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Grid,
  Container,
  Box,
  // styled,
  useMediaQuery,
  useTheme,
  Dialog,
  DialogContent,
  Avatar,
} from "@mui/material";
import { keyframes } from "@mui/system";
import Footer from "../common/Footer";
import { useNavigate } from "react-router-dom";
import { ROUTE_CLIENT_LOGIN, ROUTE_SIGNIN_NEW } from "../../constants/routes";
import YouTube from "react-youtube";
import { ACCESS_TOKEN, ROLES } from "../../constants/AppVarConstants";
import { logoutClear } from "../../redux/actions/appActions";
import { useDispatch } from "react-redux";

const Image = ({ src, alt, style }: any) => <Box component="img" src={src} alt={alt} style={style} loading="lazy" />;

const getRandomPosition = (width: any, height: any) => ({
  left: `${Math.random() * width}%`,
  top: `${Math.random() * height}%`,
});

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(00);
  }
`;

const videoContainerStyle = {
  position: "relative",
  display: "inline-block",
  cursor: "pointer",
};

// const logos = [
//   "/images/Landing-page/google-logo.png",
//   "/images/Landing-page/google-logo.png",
//   "/images/Landing-page/google-logo.png",
//   "/images/Landing-page/google-logo.png",
//   "/images/Landing-page/google-logo.png",
//   "/images/Landing-page/google-logo.png",
//   "/images/Landing-page/google-logo.png",
//   "/images/Landing-page/google-logo.png",
// ];

// const CarouselContainer = styled(Box)(({ theme }) => ({
//   overflow: "hidden",
//   whiteSpace: "nowrap",
//   width: "100%",
//   padding: theme.spacing(2, 0),
//   position: "relative",
// }));

// const CarouselTrack = styled(Box)(() => ({
//   display: "flex",
//   animation: "scroll 20s linear infinite",
//   alignItems: "center",
//   "@keyframes scroll": {
//     "0%": { transform: "translateX(0)" },
//     "100%": { transform: "translateX(-100%)" },
//   },
// }));

const LandingPageModal = ({ open, onClose }: any) => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Dialog open={open} aria-labelledby="modal-title" aria-describedby="modal-description">
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          p: { md: 6, sm: 4 },
        }}
      >
        <Avatar alt="avatar" src="/images/avatar-one.png" sx={{ width: 120, height: 120 }} />
        <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", mt: 2 }}>
          <Typography sx={{ color: "#756DE9", fontWeight: 600, textAlign: "center" }}>Hello!</Typography>
          <Typography sx={{ color: "#756DE9", fontWeight: 600, textAlign: "center" }}>
            Trying to find {isMobileScreen ? "talent" : "work"}?
          </Typography>
          <Typography sx={{ fontSize: "18px", fontWeight: 600, textAlign: "center", mt: 1 }}>
            Log in on your {isMobileScreen ? "desktop" : "mobile"} to get started
          </Typography>
        </Box>
        <Button
          sx={{
            mt: 2,
            backgroundColor: "#756DE9",
            color: "#fff",
            borderRadius: "100px",
            padding: "15px 64px",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#5a4dbf",
              color: "#fff",
              borderColor: "#5a4dbf",
            },
          }}
          onClick={onClose}
        >
          Got It
        </Button>
      </DialogContent>
    </Dialog>
  );
};

const LandingPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [playLeftVideo, setPlayLeftVideo] = useState(false);
  const [playRightVideo, setPlayRightVideo] = useState(false);
  const [playVideo1, setPlayVideo1] = useState(false);
  const [playVideo2, setPlayVideo2] = useState(false);
  const [playVideo3, setPlayVideo3] = useState(false);
  const sectionRefs = useRef<any>([]);
  const [visibleElements, setVisibleElements] = useState<any>({});
  const animatedElementsRef = useRef<any>([]);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const observerCallback = (entries: any) => {
      entries.forEach((entry: any) => {
        const elementId = entry.target.getAttribute("data-id");
        if (entry.isIntersecting) {
          setVisibleElements((prev: any) => ({ ...prev, [elementId]: true }));
        }
      });
    };

    // Set up Intersection Observer
    const observer = new IntersectionObserver(observerCallback, { threshold: 0.2 });

    // Observe each animated element
    animatedElementsRef.current.forEach((el: any) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const registerElement = (element: any) => {
    if (element && !animatedElementsRef.current.includes(element)) {
      animatedElementsRef.current.push(element);
    }
  };

  const handlePlayLeftVideo = () => {
    setPlayLeftVideo(true);
  };

  const handlePlayRightVideo = () => {
    setPlayRightVideo(true);
  };

  // const CarouselItem = styled(Box)(({ theme }) => ({
  //   flex: "0 0 auto",
  //   width: 120, // Adjust width as needed
  //   marginRight: theme.spacing(7),
  //   "& img": {
  //     width: "100%",
  //     height: "auto",
  //   },
  // }));

  const toggleModal = () => setOpen(!open);


  const loginPage = (type: string) => {
    const accessToken = localStorage.getItem(ACCESS_TOKEN);
    const roles = localStorage.getItem(ROLES);
    if(accessToken){
      if(type === "seeker" && (roles?.length === 0 || !roles)){
        redirection();
      }else if(type === "recruiter" && roles){
        redirection();
      }else{
        dispatch(logoutClear(()=>{
            redirection();
        }));
      }
    }else(
      redirection()
    );
    function redirection(){
      if(type === "seeker"){
        navigate(ROUTE_SIGNIN_NEW);
      }else{
        navigate(ROUTE_CLIENT_LOGIN);
      }
    }
  };

  return (
    <Box style={{ position: "relative" }}>
      <AppBar
        position="static"
        elevation={0}
        style={{
          backgroundColor: "#fff",
          borderBottom: "1px solid #e0e0e0",
          minHeight: isMobile ? "80px" : "",
          justifyContent: "center",
        }}
      >
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }} style={{ color: "#333", fontWeight: "bold" }}>
            <img
              src="/images/client-website/seevi-logo.png"
              alt="SeeVi Logo"
              style={{ height: "40px", marginRight: "10px" }}
            />
          </Typography>
        </Toolbar>
      </AppBar>
      <LandingPageModal open={open} onClose={toggleModal} />
      {/* Main Section with 500px height and centered content */}
      <Container
        ref={(el) => (sectionRefs.current[0] = el)}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "400px",
          position: "relative",
          textAlign: "center",
        }}
      >
        <Box>
          <Box style={{ position: "relative", zIndex: 1 }}>
            <img
              style={{ position: "absolute", width: "11px", top: "-70px", left: "200px" }}
              src="images/client-website/Ellipse-4.png"
              alt="Ellipse 4"
            />
            <img
              style={{ position: "absolute", width: "14px", top: "0px", left: "-150px" }}
              src="images/client-website/Ellipse-8.png"
              alt="Ellipse 8"
            />
            <img
              style={{ position: "absolute", width: "18px", top: "200px", left: "-150px" }}
              src="images/client-website/Ellipse-9.png"
              alt="Ellipse 9"
            />
            <img
              style={{ position: "absolute", width: "8px", top: "190px", right: "402px" }}
              src="images/client-website/Ellipse-10.png"
              alt="Ellipse 10"
            />
            <img
              style={{
                position: "absolute",
                width: "17px",
                top: isMobile ? "250px" : "200px",
                left: isMobile ? "20px" : "850px",
              }}
              src="images/client-website/Ellipse-8.png"
              alt="Ellipse 8"
            />

            <img
              style={{
                position: "absolute",
                width: "16px",
                top: isMobile ? "-20px" : "0px",
                left: isMobile ? "20px" : "850px",
              }}
              src="images/client-website/Ellipse-9.png"
              alt="Ellipse 9"
            />
            <img
              style={{ position: "absolute", width: "8px", top: "-40px", right: "102px" }}
              src="images/client-website/Ellipse-10.png"
              alt="Ellipse 10"
            />
          </Box>

          {/* Apply slide-up animation directly */}
          <Typography
            ref={(el) => registerElement(el)}
            data-id="typography-main-heading"
            variant="h4"
            component="div"
            sx={{
              fontWeight: "bold",
              color: "#333",
              marginBottom: "16px",
              fontSize: isMobile ? "24px" : "37px",
              animation: visibleElements["typography-main-heading"] ? `${slideDown} 1s ease-out` : "none",
            }}
          >
            <span
              style={{ fontWeight: "800", color: "#333", marginBottom: "16px", fontSize: isMobile ? "24px" : "37px" }}
            >
              SeeVi:
            </span>{" "}
            The Ultimate Career Matchmaker for Freshers and Early Professionals!
          </Typography>
          <Typography
            ref={(el) => registerElement(el)}
            data-id="typography-landing-text"
            variant="body1"
            color="textSecondary"
            sx={{
              maxWidth: "750px",
              margin: "0 auto",
              fontSize: isMobile ? "12px" : "14px",
              color: "#777777",
              fontWeight: "400",
              animation: visibleElements["typography-landing-text"] ? `${slideUp} 1s ease-out` : "none",
            }}
          >
            Whether you&apos;re looking for your dream job or the perfect candidate, SeeVi’s holistic profiling platform
            connects the right talent with the right opportunities. With dynamic video profiles, personality insights,
            and skill highlights, SeeVi helps candidates shine and recruiters find the perfect fit.
          </Typography>
        </Box>
      </Container>

      {/* Video Thumbnails and Video Players */}
      <Container style={{ paddingBottom: "40px" }}>
        <Grid container spacing={4} justifyContent="center">
          {/* Left Video */}
          <Grid item xs={12} sm={6}>
            <Box textAlign="center">
              {!playLeftVideo ? (
                <Box sx={videoContainerStyle} onClick={handlePlayLeftVideo}>
                  <img
                    src="/images/Landing-page/left-video.jpg"
                    alt="Discover Your Perfect Career Match"
                    style={{ width: "100%", borderRadius: "10px" }}
                  />
                  <img
                    src="images/Landing-page/youtube-icon.png"
                    alt="Play Icon"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: "64px",
                      height: "64px",
                      opacity: 0.8,
                      cursor: "pointer",
                    }}
                  />
                </Box>
              ) : (
                <YouTube
                  videoId="flsWFr_rldg"
                  opts={{
                    width: "100%",
                    playerVars: {
                      autoplay: 1,
                      controls: 1,
                      rel: 0,
                      mute: 0,
                    },
                  }}
                />
              )}
            </Box>
          </Grid>

          {/* Right Video */}
          <Grid item xs={12} sm={6}>
            <Box textAlign="center">
              {!playRightVideo ? (
                <Box sx={videoContainerStyle} onClick={handlePlayRightVideo}>
                  <img
                    src="/images/Landing-page/right-video-thumbnail.jpg"
                    alt="Find the Right Talent"
                    style={{ width: "100%", borderRadius: "10px" }}
                  />
                  <img
                    src="images/Landing-page/youtube-icon.png"
                    alt="Play Icon"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: "64px",
                      height: "64px",
                      opacity: 0.8,
                      cursor: "pointer",
                    }}
                  />
                </Box>
              ) : (
                <YouTube
                  videoId="gtIwJGfgyz8"
                  opts={{
                    width: "100%",
                    playerVars: {
                      autoplay: 1,
                      controls: 1,
                      rel: 0,
                      mute: 0,
                    },
                  }}
                />
              )}
            </Box>
          </Grid>
        </Grid>
      </Container>

      <Container ref={(el) => (sectionRefs.current[0] = el)} style={{ paddingBottom: isMobile ? "10px" : "40px" }}>
        {/* First Section: Video Profiles */}
        <Box marginBottom="40px">
          <Grid container spacing={4} style={{ marginTop: "20px" }} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography
                ref={(el) => registerElement(el)}
                data-id="typography-profile-left"
                variant="body1"
                sx={{
                  fontSize: isMobile ? "14px" : "16px",
                  fontWeight: "600",
                  color: "#1F2235",
                  animation: visibleElements["typography-profile-left"] ? `${slideUp} 1s ease-out` : "none",
                  fontStyle: "italic",
                }}
              >
                Stronger first impressions. Accurate hiring decisions.
              </Typography>

              <Typography
                ref={(el) => registerElement(el)}
                data-id="typography-profile-left-1"
                variant="body1"
                sx={{
                  fontSize: isMobile ? "18px" : "24px",
                  fontWeight: "500",
                  color: "#1F2235",
                  animation: visibleElements["typography-profile-left-1"] ? `${slideUp} 1s ease-out` : "none",
                  marginBottom: isMobile ? "20px" : "",
                }}
              >
                Both enabled by SeeVi’s Video Profiles.
              </Typography>
            </Grid>
          </Grid>
          <Grid container direction={{ xs: "column", md: "row" }} spacing={2} style={{ alignItems: "center" }}>
            {/* Content Section */}
            <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
              <Typography variant="h6" style={{ color: "#5c6bc0", fontWeight: "bold", fontSize: "14px" }}>
                Job Seeker
              </Typography>
              <Typography variant="body1" style={{ color: "#777777", marginBottom: "16px", fontSize: "14px" }}>
                A traditional CV often fails to make the right impression because it doesn’t capture your unique
                personality. SeeVi’s video profile gives you the spotlight, allowing you to present your true self to
                employers and make a lasting impression in a way paper never could.
              </Typography>

              <Typography variant="h6" style={{ color: "#ff7043", fontWeight: "bold", fontSize: "14px" }}>
                Company
              </Typography>
              <Typography variant="body1" style={{ color: "#777777", fontSize: "14px" }}>
                SeeVi’s video profiles bring candidates to life, letting you meet the person without meeting in person.
                It reveals nuances that a traditional CV simply can’t, giving you deeper insights for smarter, more
                confident hiring decisions.
              </Typography>
            </Grid>

            {/* Image Section */}
            {/* <Grid
              item
              xs={12}
              md={6}
              style={{
                position: "relative",
                textAlign: "center",
              }}
              order={{ xs: 1, md: 2 }}
            >
              <img
                src="/images/Landing-page/Group 512419.png"
                alt="Video Profile vs Traditional CV"
                style={{
                  width: isMobile ? "100%" : "70%",
                  borderRadius: "8px",
                  maxHeight: isMobile ? "auto" : "500px",
                  objectFit: "contain",
                }}
              />

              <img
                src="/images/Landing-page/Candidate.gif"
                alt="Video Profile vs Traditional CV"
                style={{
                  position: "absolute",
                  top: isMobile ? "155px" : "170px",
                  left: isMobile ? "40%" : "47%",
                  transform: isMobile ? "none" : "none",
                  width: isMobile ? "70%" : "70%",
                  height: isMobile ? "160px" : "250px",
                  borderRadius: "8px",
                  // objectFit: "contain", // Preserve aspect ratio and avoid cropping
                }}
              />
            </Grid> */}
            <Grid
              item
              xs={12}
              md={6}
              style={{
                position: "relative",
                textAlign: "center",
              }}
              order={{ xs: 1, md: 2 }}
            >
              <img
                src="/images/Landing-page/Group 512419.png"
                alt="Video Profile vs Traditional CV"
                style={{
                  display: isMobile ? "flex" : "unset",
                  width: isMobile ? "80%" : "70%",
                  borderRadius: "8px",
                  maxHeight: isMobile ? "auto" : "500px",
                }}
              />

              <img
                src="/images/Landing-page/Candidate.gif"
                alt="Video Profile vs Traditional CV"
                style={{
                  position: "absolute",
                  top: isMobile ? "120px" : "170px",
                  left: isMobile ? "68%" : "82%",
                  transform: isMobile ? "translateX(-50%)" : "translateX(-50%)",
                  width: isMobile ? "60%" : "70%",
                  height: isMobile ? "124px" : "250px",
                  borderRadius: "8px",
                  objectFit: "cover",
                  objectPosition: isMobile ? "0px -72px" : "0px -142px",
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container ref={(el) => (sectionRefs.current[0] = el)} style={{ paddingBottom: "40px" }}>
        <Box sx={{ marginBottom: isMobile ? "10px" : "40px" }}>
          <Grid container spacing={4} style={{ marginTop: isMobile ? "0px" : "20px" }} alignItems="center">
            {/* Desktop View - Image on Left, Text on Right */}
            {!isMobile && (
              <>
                {/* Image on Left */}
                <Grid item md={6} style={{ textAlign: "center" }}>
                  <img src="/images/Landing-page/personality.png" alt="The Achiever" style={{ width: "80%" }} />
                </Grid>

                {/* Text on Right */}
                <Grid item md={6}>
                  <Typography
                    ref={(el) => registerElement(el)}
                    data-id="typography-profile-right"
                    variant="body1"
                    sx={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#1F2235",
                      animation: visibleElements["typography-profile-right"] ? `${slideUp} 1s ease-out` : "none",
                      fontStyle: "italic",
                    }}
                  >
                    Uncover the personality and discover the potential
                  </Typography>

                  <Typography
                    ref={(el) => registerElement(el)}
                    data-id="typography-profile-right-1"
                    variant="body1"
                    sx={{
                      marginBottom: "16px",
                      fontSize: "24px",
                      fontWeight: "500",
                      color: "#1F2235",
                      animation: visibleElements["typography-profile-right-1"] ? `${slideUp} 1s ease-out` : "none",
                    }}
                  >
                    with SeeVi’s WorkWise Personality Profiler.
                  </Typography>

                  <Typography variant="h6" style={{ color: "#5c6bc0", fontWeight: "bold", fontSize: "14px" }}>
                    Job Seeker
                  </Typography>
                  <Typography variant="body1" style={{ color: "#777777", marginBottom: "16px", fontSize: "14px" }}>
                    SeeVi&apos;s WorkWise Personality Profiler helps you learn about your personality type, skills, and
                    traits to find opportunities that align with your natural strengths. This understanding will ensure
                    that work is not just a job but a source of joy and fulfillment.
                  </Typography>

                  <Typography variant="h6" style={{ color: "#ff7043", fontWeight: "bold", fontSize: "14px" }}>
                    Company
                  </Typography>
                  <Typography variant="body1" style={{ color: "#777777", fontSize: "14px" }}>
                    Every personality thrives in the right culture, and understanding this is key to long-term success.
                    SeeVi&apos;s WorkWise Personality Report offers insights into each candidate&apos;s fit within your
                    organization, enabling accurate hiring decisions and improving retention and overall success.
                  </Typography>
                </Grid>
              </>
            )}

            {/* Mobile View - Image in Between Header and Content */}
            {isMobile && (
              <>
                {/* Header Text */}
                <Grid item xs={12}>
                  <Typography
                    ref={(el) => registerElement(el)}
                    data-id="typography-profile-right"
                    variant="body1"
                    sx={{
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#1F2235",
                      animation: visibleElements["typography-profile-right"] ? `${slideUp} 1s ease-out` : "none",
                      fontStyle: "italic",
                    }}
                  >
                    Uncover the personality and discover the potential
                  </Typography>

                  <Typography
                    ref={(el) => registerElement(el)}
                    data-id="typography-profile-right-1"
                    variant="body1"
                    sx={{
                      marginBottom: "16px",
                      fontSize: "18px",
                      fontWeight: "500",
                      color: "#1F2235",
                      animation: visibleElements["typography-profile-right-1"] ? `${slideUp} 1s ease-out` : "none",
                    }}
                  >
                    with SeeVi’s WorkWise Personality Profiler.
                  </Typography>
                </Grid>

                {/* Image in Middle */}
                <Grid item xs={12} style={{ textAlign: "center" }}>
                  <img src="/images/Landing-page/personality.png" alt="The Achiever" style={{ width: "100%" }} />
                </Grid>

                {/* Remaining Content */}
                <Grid item xs={12}>
                  <Typography variant="h6" style={{ color: "#5c6bc0", fontWeight: "bold", fontSize: "14px" }}>
                    Job Seeker
                  </Typography>
                  <Typography variant="body1" style={{ color: "#777777", marginBottom: "16px", fontSize: "14px" }}>
                    SeeVi’s WorkWise Personality Profiler helps you learn about your personality type, skills, and
                    traits to find opportunities that align with your natural strengths. This understanding will ensure
                    that work is not just a job but a source of joy and fulfillment.
                  </Typography>

                  <Typography variant="h6" style={{ color: "#ff7043", fontWeight: "bold", fontSize: "14px" }}>
                    Company
                  </Typography>
                  <Typography variant="body1" style={{ color: "#777777", fontSize: "14px" }}>
                    Every personality thrives in the right culture, and understanding this is key to long-term success.
                    SeeVi’s WorkWise Personality Report offers insights into each candidate’s fit within your
                    organization, enabling accurate hiring decisions and improving retention and overall success.
                  </Typography>
                </Grid>
              </>
            )}
          </Grid>
        </Box>
      </Container>

      <Container ref={(el) => (sectionRefs.current[0] = el)} style={{ paddingBottom: "40px" }}>
        <Box marginBottom="40px">
          <Grid container spacing={4} style={{ marginTop: "20px" }} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography
                ref={(el) => registerElement(el)}
                data-id="typography-resume-left"
                variant="body1"
                sx={{
                  fontSize: isMobile ? "14px" : "16px",
                  fontWeight: "600",
                  color: "#1F2235",
                  animation: visibleElements["typography-resume-left"] ? `${slideUp} 1s ease-out` : "none",
                  fontStyle: "italic",
                }}
              >
                Not just resumes with jobs,
              </Typography>

              <Typography
                ref={(el) => registerElement(el)}
                data-id="typography-resume-left-1"
                variant="body1"
                sx={{
                  marginBottom: "16px",
                  fontSize: isMobile ? "18px" : "24px",
                  fontWeight: "500",
                  color: "#1F2235",
                  animation: visibleElements["typography-resume-left-1"] ? `${slideUp} 1s ease-out` : "none",
                }}
              >
                SeeVi&apos;s holistic profiling matches potential with opportunities.
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={4} alignItems="center" direction={{ xs: "column-reverse", md: "row" }}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" style={{ color: "#5c6bc0", fontWeight: "bold", fontSize: "14px" }}>
                Job Seeker
              </Typography>
              <Typography variant="body1" style={{ color: "#777777", marginBottom: "16px", fontSize: "14px" }}>
                SeeVi&apos;s holistic profiling goes beyond the basics of a traditional resume, matching you with
                opportunities that align with your interests, preferences and personality. Discover careers not just
                jobs where you can thrive and grow with SeeVi.
              </Typography>

              <Typography variant="h6" style={{ color: "#ff7043", fontWeight: "bold", fontSize: "14px" }}>
                Company
              </Typography>
              <Typography variant="body1" style={{ color: "#777777", fontSize: "14px" }}>
                SeeVi&apos;s holistic profiling combines dynamic video profiles, personality insights and skill
                highlights to find the right candidate not just the right resume. Make informed hiring decisions and
                ensure a perfect cultural fit for long-term success.
              </Typography>
            </Grid>

            <Grid item xs={12} md={6} style={{ textAlign: "center" }}>
              <img
                src="/images/Landing-page/Profiling.png"
                alt="Video Profile vs Traditional CV"
                style={{ width: "80%", borderRadius: "8px" }}
              />
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container ref={(el) => (sectionRefs.current[0] = el)} style={{ paddingBottom: "40px" }}>
        <Box marginBottom="20px" marginTop="20px">
          <Typography
            ref={(el) => registerElement(el)}
            data-id="typography-interesting-2"
            variant="body1"
            sx={{
              marginBottom: "16px",
              fontSize: "24px",
              fontWeight: "600",
              color: "#111111",
              animation: visibleElements["typography-interesting-2"] ? `${slideUp} 1s ease-out` : "none",
            }}
          >
            Some interesting examples of video profiles
          </Typography>

          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography variant="h6" style={{ color: "#000000", fontWeight: "bold", fontSize: "14px" }}>
                About You
              </Typography>
              <Typography variant="body1" style={{ color: "#000000", marginBottom: "16px", fontSize: "14px" }}>
                Your interests outside of work
              </Typography>
              <Grid item xs={12}>
                <Box textAlign="center">
                  {!playVideo1 ? (
                    <Box sx={videoContainerStyle} onClick={() => setPlayVideo1(true)}>
                      <img
                        src="/images/Landing-page/resume-profile.png"
                        alt="Discover Your Perfect Career Match"
                        style={{ width: "100%", borderRadius: "10px" }}
                      />
                      <img
                        src="images/Landing-page/youtube-icon.png"
                        alt="Play Icon"
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          width: "64px",
                          height: "64px",
                          opacity: 0.8,
                          cursor: "pointer",
                        }}
                      />
                    </Box>
                  ) : (
                    <YouTube
                      videoId="9NAh4UBcn0Q"
                      opts={{
                        width: "100%",
                        playerVars: {
                          autoplay: 1,
                          controls: 1,
                          rel: 0,
                          mute: 0,
                        },
                      }}
                    />
                  )}
                </Box>
              </Grid>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="h6" style={{ color: "#000000", fontWeight: "bold", fontSize: "14px" }}>
                Your Specializations & Projects
              </Typography>
              <Typography variant="body1" style={{ color: "#000000", marginBottom: "16px", fontSize: "14px" }}>
                An academic achievement that you are proud of
              </Typography>
              <Grid item xs={12}>
                <Box textAlign="center">
                  {!playVideo2 ? (
                    <Box sx={videoContainerStyle} onClick={() => setPlayVideo2(true)}>
                      <img
                        src="/images/Landing-page/resume-profile.png"
                        alt="Discover Your Perfect Career Match"
                        style={{ width: "100%", borderRadius: "10px" }}
                      />
                      <img
                        src="images/Landing-page/youtube-icon.png"
                        alt="Play Icon"
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          width: "64px",
                          height: "64px",
                          opacity: 0.8,
                          cursor: "pointer",
                        }}
                      />
                    </Box>
                  ) : (
                    <YouTube
                      videoId="1GlwJJk92ZE"
                      opts={{
                        width: "100%",
                        playerVars: {
                          autoplay: 1,
                          controls: 1,
                          rel: 0,
                          mute: 0,
                        },
                      }}
                    />
                  )}
                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={4} style={{ marginTop: "20px" }} alignItems="center">
            <Grid item xs={12}>
              <Typography
                variant="h6"
                style={{
                  color: "#000000",
                  fontWeight: "bold",
                  fontSize: "14px",
                  textAlign: "left",
                  marginLeft: isMobile ? "0%" : "25%",
                }}
              >
                You@work
              </Typography>
              <Typography
                variant="body1"
                style={{
                  color: "#000000",
                  marginBottom: "16px",
                  fontSize: "14px",
                  textAlign: "left",
                  marginLeft: isMobile ? "0%" : "25%",
                }}
              >
                A work environment that you thrive in
              </Typography>
              <Grid container>
                <Grid item xs={0} md={3}></Grid>
                <Grid item xs={12} md={6} sx={{ maxWidth: "100%" }}>
                  <Box>
                    {!playVideo3 ? (
                      <Box
                        sx={videoContainerStyle}
                        onClick={() => setPlayVideo3(true)}
                        style={{ position: "relative" }} // Ensure the container is positioned relatively for the play icon
                      >
                        <img
                          src="/images/Landing-page/resume-profile.png"
                          alt="Discover Your Perfect Career Match"
                          style={{
                            width: "100%",
                            borderRadius: "10px",
                          }}
                        />
                        <img
                          src="images/Landing-page/youtube-icon.png"
                          alt="Play Icon"
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "64px",
                            height: "64px",
                            opacity: 0.8,
                            cursor: "pointer",
                          }}
                        />
                      </Box>
                    ) : (
                      <YouTube
                        videoId="S9lvkRkI5HI"
                        opts={{
                          width: "100%",
                          playerVars: {
                            autoplay: 1,
                            controls: 1,
                            rel: 0,
                            mute: 0,
                          },
                        }}
                      />
                    )}
                  </Box>
                </Grid>
                <Grid item xs={0} md={3}></Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container ref={(el) => (sectionRefs.current[0] = el)} style={{ paddingBottom: "40px" }}>
        <Box marginTop="20px">
          <Typography
            ref={(el) => registerElement(el)}
            data-id="typography-reimagine-2"
            variant="body1"
            sx={{
              marginBottom: "16px",
              fontSize: "24px",
              fontWeight: "600",
              color: "#111111",
              animation: visibleElements["typography-reimagine-2"] ? `${slideUp} 1s ease-out` : "none",
            }}
          >
            Reimagine Job posts
          </Typography>
        </Box>
      </Container>

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          paddingY: "4%",
          alignItems: "flex-start",
          height: "auto",
          position: "relative",
          textAlign: "center",
          backgroundColor: "#756DE9",
        }}
      >
        <Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: isMobile ? "100%" : "85%",
              position: "relative", // Container for ellipses and carousel
            }}
          >
            {/* Carousel */}
            <Carousel
              showArrows={isMobile ? true : false}
              showStatus={false}
              showThumbs={false}
              // infiniteLoop={true}
              swipeable={isMobile ? true : false}
              centerMode={true}
              centerSlidePercentage={isMobile ? 70 : 33.33}
              showIndicators={isMobile ? true : false}
              autoPlay
            >
              {(isMobile ? [1, 2, 3] : [1, 2, 3]).map((imageIndex) => (
                <div
                  key={imageIndex}
                  style={{
                    marginRight: isMobile ? "5%" : "45px",
                    marginLeft: isMobile ? "5%" : "45px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <img
                    src={`/images/Landing-page/${imageIndex}.jpg`}
                    alt={`Image ${imageIndex}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      border: "2px solid #FFFFFF",
                      borderRadius: "20px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "#fff",
                    }}
                  />
                </div>
              ))}
            </Carousel>

            {/* Ellipse Images */}
            {!isMobile && (
              <Box
                sx={{
                  width: "40%",
                  height: "200px", // Space for ellipses below the carousel
                  position: "relative", // Position reference for ellipses
                  mt: 2, // Margin above the ellipse container
                }}
              >
                <Box sx={{ position: "absolute", ...getRandomPosition(100, 200) }}>
                  <Image src="/images/Ellipse-10.png" alt="Image 1" style={{ width: "10px", height: "10px" }} />
                </Box>
                <Box sx={{ position: "absolute", ...getRandomPosition(100, 200) }}>
                  <Image src="/images/Ellipse-15.png" alt="Image 2" style={{ width: "10px", height: "10px" }} />
                </Box>
                <Box sx={{ position: "absolute", ...getRandomPosition(100, 200) }}>
                  <Image src="/images/Ellipse-16.png" alt="Image 3" style={{ width: "12px", height: "12px" }} />
                </Box>
                <Box sx={{ position: "absolute", ...getRandomPosition(100, 200) }}>
                  <Image src="/images/Ellipse-20.png" alt="Image 4" style={{ width: "8px", height: "8px" }} />
                </Box>

                <Box sx={{ position: "absolute", ...getRandomPosition(100, 200) }}>
                  <Image src="/images/Ellipse-21.png" alt="Image 5" style={{ width: "9px", height: "9px" }} />
                </Box>
                <Box sx={{ position: "absolute", ...getRandomPosition(100, 200) }}>
                  <Image src="/images/Ellipse-22.png" alt="Image 6" style={{ width: "6px", height: "6px" }} />
                </Box>
                <Box sx={{ position: "absolute", ...getRandomPosition(100, 200) }}>
                  <Image src="/images/Ellipse-23.png" alt="Image 7" style={{ width: "8px", height: "8px" }} />
                </Box>
              </Box>
            )}
          </Box>
          {isMobile ? null : (
            <img
              src="/images/Landing-page/girl-landing.png"
              alt="Discover Your Perfect Career Match"
              style={{
                width: isMobile ? "30%" : "20%",
                position: "absolute",
                bottom: "0px",
                right: "10px",
                marginLeft: "-70px",
              }}
            />
          )}
        </Box>
      </Box>

      {/* <Container
        style={{
          display: "flex",
          height: "250px",
          position: "relative",
          flexDirection: "column",
          marginBottom: "100px",
        }}
      >
        <Box marginBottom="20px" marginTop="100px">
          <Typography
            ref={(el) => registerElement(el)}
            data-id="typography-companies-2"
            variant="body1"
            sx={{
              marginBottom: "16px",
              fontSize: "24px",
              fontWeight: "600",
              color: "#111111",
              animation: visibleElements["typography-companies-2"] ? `${slideUp} 1s ease-out` : "none",
            }}
          >
            Companies On SeeVi
          </Typography>
        </Box>

        <CarouselContainer>
          <CarouselTrack>
            {logos.concat(logos).map((logo, index) => (
              <CarouselItem key={index}>
                <img src={logo} alt={`Logo ${index + 1}`} />
              </CarouselItem>
            ))}
          </CarouselTrack>
        </CarouselContainer>
      </Container> */}

      <Footer />
    </Box>
  );
};

export default LandingPage;
